var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upgrade-to-company"},[_c('b-container',[_c('ProfileInfo',{attrs:{"userType":_vm.userType}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }